export default __webpack_public_path__ + "assets/video-mask.fb7bc262.svg";